import React, { Component } from 'react';
import { parseServerTime } from './helpers/time.helper';

class FriendlyDate extends Component {
    render() {
        return (
            <span>
                {parseServerTime(this.props.timestamp).toLocaleString('en-GB')}
            </span>
        );
    }
}

export default FriendlyDate;
